<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10" v-if="listBill">
            <v-row style="position:relative;">
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Оплата безналичными средствами (Создание) </div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Оплата безналичными средствами (Создание)</div>

                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet
                    max-height="1000px"
                    rounded="lg"
                    class="d-flex card"
                    style="flex-direction:column; padding:10px 20px 40px 20px;"
                >
                <v-row class="d-flex justify-space-between mt-5">

                    <div style="width: 50%; display: flex; align-items: start; flex-direction: column; padding:0px 20px;">
                        <span class="" style="color:#000; font-size: 16px; line-height:24px; font-weight: bold;">Вид средств</span>
                        <dIv style="margin-top:26px; display:flex; align-items: center; width:100%; height:42px; margin-right:40px;">
                          <v-select
                                v-model="buyer_sale_type"
                                :items="buyer_sale_type_list ? buyer_sale_type_list : []"
                                :item-text="item=>`${item.name}`"
                                return-object
                                class="rounded-lg"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                style="width:200px; margin:0px 0px;"
                            ></v-select>
                        </div>
                      </div>

                      <div style="width: 50%; display: flex; align-items: start; flex-direction: column;  padding:0px 20px;">

                        <span style="font-weight: bold;">Касса</span>
                        <v-select
                            v-if="listCashbox && listCashbox.length > 0"
                            v-model="sale.org"
                            :items="listCashbox"
                            item-value="inn"
                            item-text="legal_entity"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg(item)"
                            style="height:42px; width:100%; margin:15px 0px;"
                        ></v-select>
                        <v-select
                            v-else-if="listOrganizations && listOrganizations.sales"
                            v-model="saleOrg"
                            :items="listOrganizations.sales"
                            item-value="inn"
                            item-text="name"
                            return-object
                            label="Выбрать"
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            @change="ChangeSaleOrg(item)"
                            style="height:42px; width:100%; margin:15px 0px;"
                        ></v-select>
                      </div>

                    </v-row>

                    <v-row class="d-flex justify-space-between mt-5">

                      <div style="width: 50%; display: flex; align-items: start; flex-direction: column; padding:0px 20px; ">
                          <span class="" style="color:#000; font-size: 16px; line-height:24px; font-weight: bold;">Сумма</span>
                          <!-- <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%;  display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px; ">
                            <span>{{ this.summ_cash_part_buyer }}</span>
                          </div> -->
                          <v-text-field
                                v-model="summ_part_buyer"
                                :rules="makeSummRules"
                                placeholder="0"
                                outlined
                                dense
                                class="rounded-lg"
                                color="#629F33"
                                ref="makeSummRulesRef"
                                style="width:100%; margin-top:15px;"
                            >
                          </v-text-field>
                        </div>

                        <div style="width: 50%; display: flex; align-items: start; flex-direction: column; padding:0px 20px;">

                          <span class="" style="color:#000; font-size: 16px; line-height:24px; font-weight: bold;">Счёт</span>

                          <dIv style="display:flex; align-items: center; width:100%; height:42px; margin-top:16px;">
                            <v-select
                                  v-model="buyer_sale_main"
                                  :items="listBill ? listBill.list : []"
                                  item-value="id"
                                  item-text="name"
                                  class="rounded-lg"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  color="#629F33"
                                  style="height:42px; width:100%; margin:15px 0px;"
                              ></v-select>
                          </div>
                        </div>

                      </v-row>

                </v-sheet>

                <v-sheet
                    max-height="1000px"
                    rounded="lg"
                    class="d-flex card"
                    style="flex-direction:column; margin-top:20px; padding:10px 40px 40px 40px;"
                >
                <v-row class="d-flex justify-space-between mt-5">

                    <div style="width: 50%; display: flex; align-items: start; flex-direction: column;">
                        <span class="" style="color:#000; font-size: 16px; line-height:24px; font-weight:bold;">Клиент</span>
                        <dIv style="margin-top:16px; padding:16px; display:flex; align-items: center; width:100%; display:flex; align-items: center; width:100%; height:42px; border:1px solid #E0E0E0; border-radius:10px;  ">
                          <div v-if="client_name_buyer">
                            {{ client_name_buyer }}
                          </div>
                          <div v-else>
                            Клиент 
                          </div>
                        </div>
                      </div>

                      <div>

                      </div>

                </v-row>

                    <v-row class="d-flex" style="background:#fefece; flex-direction:column; margin:40px -12px; border:1px solid #e0e0e0;" v-if="service_list_buyer">

                      <div class="d-flex justify-space-between" v-for="deal in service_list_buyer" :key="deal.id" style="padding:0px 0px; align-items:center;">
                          <div style="width: 15%; display: flex; align-items: start; flex-direction: column;  padding-left: 10px;">
                            <span class="" style="color:#000; font-size: 16px; line-height:24px;">{{ deal.count }}</span>
                      
                        </div>

                        <div style="width: 75%; display: flex; align-items: start; flex-direction: column; border-left:0px solid #e0e0e0;">
                            <span class="" style="color:#000; font-size: 16px; line-height:24px;" v-if="deal && deal.service">{{ deal.service.name }}</span>
                            <span class="" style="color:#000; font-size: 16px; line-height:24px;" v-else-if="deal && deal.service_name">{{ deal.service_name }}</span>
                        </div>

                        <div style="width: 15%; display: flex;   flex-direction: column; align-items: end; padding:10px 10px;">
                            <span class="" style="color:#000; font-size: 16px; line-height:24px;">{{ deal.price }}</span>
                      
                        </div>
                      </div>
          
              
                      </v-row>

                      <v-row>
                        <span style="color:#000; font-size: 16px; line-height:24px; font-weight:bold;">Комментарий</span>
                        <v-textarea
                                v-model="buyer_text"
                                placeholder="Написать..."
                                rounded
                                outlined
                                dense
                                required
                                auto-grow
                                background-color="#fff"
                                rows="5"
                                style="width: 100%; height: 150px"
                            ></v-textarea>
                      </v-row>

                      <v-row class="d-flex justify-space-between">
                        <v-btn class="button__secondary button__secondary-text" :disabled="isLoadingSale" @click="removeBuyer()">

                          <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>

                          Удалить запись
                        </v-btn>

                        <v-btn v-if="buyer_sale_main && (+summ_part_buyer > 0)" class="button__success" :disabled="isLoadingSale" @click="payBuyer()">
                          <span v-if="detail">Изменить</span>
                          <span v-else>Оплатить</span>
                        </v-btn>

                        <v-btn v-else class="button__secondary button__secondary-text" :disabled="isLoadingSale" >
                          <span v-if="detail">Изменить</span>
                          <span v-else>Оплатить</span>
                        </v-btn>

                      </v-row>

                </v-sheet>

              </v-col>
   
            </v-row>
          </v-container>
        </v-row>


      </v-container>
    </v-main>
  </v-app>
</template>
<script>
//import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {salesActionTypes} from "@/store/modules/sale";
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {getItem, setItem} from "../helpers/persistanceStorage";
import {billActionTypes} from "@/store/modules/bill";
import {dealsActionTypes} from "@/store/modules/deals";
import {lessonActionTypes} from "@/store/modules/lesson";
export default {
  name: "SaleBuyer",
  props: ['client_id','client_name_buyer','org_inn','service_list_buyer','buy_id','summ_cash_part_buyer','summ_part_buyer','detail','pays','new_org'],
  components: {
    Header,
    Menu
  },
  data() {
    return {
      chosedRentalType:null,
      rentaItemDialogNumber:false,
      dialogPayment2:false,
      salePart:true,
      sale_org_changed:false,
      searchService: null,
      showServices: false,
      dialogPayment: false,
      dialogClient: false,
      dialogTypeOfPayment: null,
      dialogTypeOfPaymentPart:[0,1,2,3],
      sale_tab: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      main_bill: null,
      main_bill_part_def:null,
      main_bill_part:null,
      main_bill_part2:null,
      mainBillRules: [
        v => !!v || 'Нужно выбрать лицевой счет',
        v => parseInt(v.bill_balance) !== 0 || 'Нулевой баланс счёта'
      ],
      mainBonusRules: [
        v => !!v || 'Нужно выбрать бонусный счет',
        v => parseInt(v.bonus_balance) !== 0 || 'Нулевой баланс счёта',
        //v => parseInt(v.bonus_limit) < this.summ_bonus_part_pre || 'Превышен лимит'
      ],
      sortBy: 'total',
      sortDesc: false,
      check_to: 0,
      cash_in: null,
      //v => parseInt(v) !== 0 || 'Введите внесенную сумму'
      cashInFreeRules: [
        v => (v >= 0) || 'Введите внесенную сумму'
      ],
      cashInRules: [
        v => (v >= 0) || 'Введите внесенную сумму',
        v => parseInt(v) !== 0 || 'Введите внесенную сумму',
        v => !!v || 'Введите сумму'
      ],
      cash_out: 0,
      cash_from_bill: 0,
      cash_in_part: 0,
      cash_out_part: 0,
      // summ_cash_part:null,
      // summ_card_part:null,
      //v => parseInt(v) !== 0 || 'Введите сумму',
      //v => !!v || 'Введите сумму',
      cashFromBillRules: [
        v => parseInt(v) <= this.main_bill?.deposit_balance || 'Введите сумму не больше Л/С'
      ],
      buy_id_payment: null,
      sales: [
        {tab: 'Номенклатура'},
        {tab: 'Дополнительно'}
      ],
      sale: {
        number: null,
        date: new Date(),
        org: null,
        promocode: null,
      },
      listCashboxDef:[
        {
            inn:"1650387117",
            legal_entity:"OOO",
            serial:"0010872001250"
        },
        {
            inn:"165038711733",
            legal_entity:"IP",
            serial:"0010872001250333"
        }
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      headersNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'НДС', sortable: false, value: 'vat'},
        {text: 'Скидка', sortable: false, value: 'discount', width: '10%'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
        {text: '', value: 'actions', sortable: false},
      ],
      headersExistNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'Скидка', sortable: false, value: 'discount'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
      ],
      headersRentals:[
        {text: 'Наименование услуги', sortable: false, value: 'name'},
        {text: 'Количество услуги', sortable: false, value: 'rental.duration_of_action_def'},
        {text: 'Номер шкафа/ячейки', sortable: false, value: 'rentalType.name'},
        {text: 'Дата и время начала аренды', sortable: false, value: 'date_time_start'},
        {text: 'Дата и время заверения аренды', sortable: false, value: 'return_date'},
        {text: 'Цена услуги', sortable: false, value: 'price'},
        {text: 'Всего', sortable: false, value: 'total'},
        {text: '', value: 'actions', sortable: false},
      ],
      nomenclatures: [],
      specialist_id:null,
      caseSensitive:false,
      saleOrg:null,
      specialistDef:[
        {
          id:"1",
          name:"test1"
        },
        {
          id:"2",
          name:"test2"
        }
      ],
      myTree:[],
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      term_i:0,
      summ_cash_part:0,
      summ_card_part:0,
      summ_bill_part:0,
      summ_bill_part2:0,
      summ_part:0,
      main_bill_part_pre:0,
      summ_cash_part_pre:0,
      summ_card_part_pre:0,
      summ_bill_part_pre:0,
      summ_bill_part_pre2:0,
      cash_in_part_pre:0,
      cash_in_part_setted:false,
      card_part_setted:false,
      bill_part_setted:false,
      bill_part_setted2:false,
      bonus_part_setted:false,
      main_bonus_part:null,
      summ_bonus_part_pre:0,
      ifCardPay:false,
      ifCashPay:false,
      canAddSumm:false,
      buy_payment_list:null,
      rentaItemDialog:false,
      rentaItem:{},
      rentaItemDef:[
        {
          id:"e154f6f8-eced-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 6 месяцев (клевер)",
          price:4950,
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 6,
            duration_of_action_def:6,
            create_rent: true
         }
        },
        {
          id:"23d56db0-ed07-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 1 месяц (клевер)",
          price:1650,
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 1,
            duration_of_action_def:1,
            create_rent: true
         }
        },
        {
          id:"36aa21da-ef56-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на год (VIP) (клевер)",
          price:"0",
          date_time_start:null,
          date_time_end:null,
          return_date:null,
          return_time:null,
          activation_type: "",
          rental_type: "Шкафы",
          rental: {
            type_locker_id: "c214ad10-f010-11ea-812c-9c5c8e747603",
            type_locker_name: "шкафы клевер",
            type_of_tariff: "Месяц",
            duration_of_action: 12,
            duration_of_action_def:12,
            create_rent: true
         }
        }
      ],
      date:new Date(),
      date2:new Date(),
      date3:new Date(),
      start_age:1,
      rulesMonth: [
         v => !!v || 'Required',
         v => v >= 1 || 'Минимум 1'
      ],
      rentalArray:[],
      rentalFormLoading:false,
      endAgeRules:  [
        v => {
          if (v >= 0 && v !== '' && v !== null) return /^\d+$/.test(v) && v >= (this.start_age + 1) && v <= 350 || 'Введите число от 1';
          else return true;
        }
      ],
      showHeaderNew:false,
      noCountServices:{
        'АбонементЧленство': 'АбонементЧленство',
        'МодификаторЧленствПакетов': 'МодификаторЧленствПакетов',
        'ПодарочныйСертификат': 'ПодарочныйСертификат'
      },
      buyerSaleModal:false,
      buyer_sale_type_list:[
        {
          "name":"Безналичные",
          "id":1
        }
      ],
      buyer_sale_type:{
        "name":"Безналичные",
        "id":1
      },
      buyer_sale_main:null,
      buyer_text:'',
      makeSummRules: [
        v => !!v || 'Сумма обязательная',
        v => (v <= this.summ_cash_part_buyer) || 'Превышена сумма продажи'
      ]
    }
  },
  methods: {
    removeBuyer(){
      this.$store.dispatch(cashboxActionTypes.saleReceiptBuyer, {
                        pay_id:this.pays[0].id,
                        remove:true
                      })
                          .then((response) => {
                                    if (response.success) {
                                      this.$router.push({
                                              name: 'Desktop',
                                              params: {
                                                client_id: this.client_id
                                              }
                                            });
                                    } else {
                                      alert('Ошибка удаления документа безналичной оплаты!');
                                    }
                        })
    },
    payBuyer(){
      
      if (this.$refs.makeSummRulesRef.validate()) {

        if(this.detail){
        
          console.log(this.summ_part_buyer)

          let buyListAr = []
          buyListAr.push(this.buy_id)

          this.$store.dispatch(cashboxActionTypes.saleReceiptBuyer, {
                        client_id: this.client_id,
                        till_id: '00108723658089',
                        buy_list: buyListAr,
                        summ: +this.summ_part_buyer,
                        bank_account: this.buyer_sale_main.id ? this.buyer_sale_main.id : this.buyer_sale_main,
                        org_id: this.saleOrg.id,
                        comment:this.buyer_text,
                        pay_id:this.pays[0].id,
                        modify:true
                      })
                          .then((response) => {
                                    if (response.success) {
                                      this.$router.push({
                                              name: 'Desktop',
                                              params: {
                                                client_id: this.client_id
                                              }
                                            });
                                    } else {
                                      alert('Ошибка изменения документа безналичной оплаты!');
                                    }
                        })

      } else {

        console.log(this.summ_part_buyer)

          let buyListAr = []
          buyListAr.push(this.buy_id)

          this.$store.dispatch(cashboxActionTypes.saleReceiptBuyer, {
                        client_id: this.client_id,
                        till_id: '00108723658089',
                        buy_list: buyListAr,
                        summ: +this.summ_part_buyer,
                        bank_account: this.buyer_sale_main.id ? this.buyer_sale_main.id : this.buyer_sale_main,
                        org_id: this.saleOrg.id,
                        comment:this.buyer_text
                      })
                          .then((response) => {
                                    if (response.success) {
                                      this.$router.push({
                                              name: 'Desktop',
                                              params: {
                                                client_id: this.client_id
                                              }
                                            });
                                    } else {
                                      alert('Ошибка оплаты безналичной!');
                                    }
                        })


      }


      } else {
        console.log('neok')
      }

   
    },
    checkClosePay(){

      let buyId = (this.saleInfo && this.saleInfo.sales && this.saleInfo.sales.id) ? this.saleInfo.sales.id : (this.buy_id_payment ? this.buy_id_payment : null)

      if(buyId) {
        let confirmText = "Пометить Продажу на удаление?"

          if (confirm(confirmText) == true) {
              this.$store.dispatch(salesActionTypes.buyDelete, {
              buy_id: buyId,
              status: true
          })
          .then((response) => {
              console.log(response)
              this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:buyId});
              this.dialogPayment2 = false
          });

          } else {
            this.dialogPayment2 = false
          }

      } else {
        console.log('nettuuu')
        this.dialogPayment2 = false
      }

    },

    downEndAge() {
      if (this.rentaItem.rental.duration_of_action_def === '' || this.rentaItem.rental.duration_of_action_def === null) {
        
        if(this.rentaItem.rental.duration_of_action === 6){
          this.rentaItem.rental.duration_of_action_def = 6;
        }
        if(this.rentaItem.rental.duration_of_action === 1){
          this.rentaItem.rental.duration_of_action_def = 1;
        }
        if(this.rentaItem.rental.duration_of_action === 12){
          this.rentaItem.rental.duration_of_action_def = 12;
        }
      } else {
        if (this.rentaItem.rental.duration_of_action_def !== 0) {
          if(this.rentaItem.rental.duration_of_action === 6){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 6
            if(this.rentaItem.rental.duration_of_action_def < 6){
              this.rentaItem.rental.duration_of_action_def = 6
            }
            
          }
          if(this.rentaItem.rental.duration_of_action === 1){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 1
            if(this.rentaItem.rental.duration_of_action_def < 1){
              this.rentaItem.rental.duration_of_action_def = 1
            }
          }
          if(this.rentaItem.rental.duration_of_action === 12){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def - 12
            if(this.rentaItem.rental.duration_of_action_def < 12){
              this.rentaItem.rental.duration_of_action_def = 12
            }
          }
        }
      }

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);
    },
    upEndAge() {
      if (this.rentaItem.rental.duration_of_action_def === '' || this.rentaItem.rental.duration_of_action_def === null) {
        if(this.rentaItem.rental.duration_of_action === 12){
          this.rentaItem.rental.duration_of_action_def = 12;
        }
      } else {
        if (this.rentaItem.rental.duration_of_action_def !== 0) {
          if(this.rentaItem.rental.duration_of_action === 6){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 6
            if(this.rentaItem.rental.duration_of_action_def < 6){
              this.rentaItem.rental.duration_of_action_def = 6
            }
            
          }
          if(this.rentaItem.rental.duration_of_action === 1){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 1
            if(this.rentaItem.rental.duration_of_action_def < 1){
              this.rentaItem.rental.duration_of_action_def = 1
            }
          }
          if(this.rentaItem.rental.duration_of_action === 12){
            this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action_def + 12
            if(this.rentaItem.rental.duration_of_action_def < 12){
              this.rentaItem.rental.duration_of_action_def = 12
            }
          }
        }
      }

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

    },

    dateChange(){

      console.log('date-changed')

      let normMon = this.rentaItem.rental.duration_of_action_def

      let date = this.rentaItem.date_time_start

      this.rentaItem.return_date = new Date(new Date(date).setMonth(new Date(date).getMonth() + normMon));

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

    },
    changeMonths(){

      this.$set(this.rentaItem.rental, 'summ', (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price)

      this.rentalFormLoading = true

      const FLASH_TIMEOUT = 150;

      setTimeout(() => {
        this.rentalFormLoading = false;
      }, FLASH_TIMEOUT);

      //this.$refs.formRent.reset();

      console.log(this.rentaItem)
      // let normMon = +this.rentaItem.rental.duration_of_action
      // this.rentaItem.return_date = null
      // if((+this.rentaItem.rental.duration_of_action_def < 1) || (!Number.isInteger(+this.rentaItem.rental.duration_of_action_def))){
      //   this.rentaItem.rental.duration_of_action_def = normMon
      //   this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + normMon));
      //   console.log('Не верно')
      // } else {
      //   let date = new Date()
      //   this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action_def));
      // }
    },

    buyDeletion(status){
      console.log(!status)

      let confirmText = "Пометить 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' на удаление?"
      if(!status === false) {
        confirmText = "Снять с 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' пометку на удаление?"
      }

        if (confirm(confirmText) == true) {

          this.$store.dispatch(salesActionTypes.buyDelete, {
              buy_id: this.saleInfo.sales.id ? this.saleInfo.sales.id : (this.buy_id_payment ? this.buy_id_payment : null),
              status: !status
          })
          .then((response) => {
              console.log(response)
              this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:this.saleInfo.sales.id});
          });

        }


    },
    buyDeletion2(buyid){

      let confirmText = "Пометить Продажу на удаление?"

      if (confirm(confirmText) == true) {

        this.$store.dispatch(salesActionTypes.buyDelete, {
            buy_id: buyid,
            status: true
        })
        .then((response) => {
            console.log(response)
            this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:buyid});
        });

        }
        
    },
    checkSumm(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      } else {
        this.canAddSumm = true
      }
    },
    toCashPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCashPay){
        this.ifCashPay = false
        
        
        if(this.cash_in_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        }
        this.cash_in_part_setted = false
        this.cash_in_part_pre = 0
      } else {
        this.cash_in_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCashPay = true
      }
    },
    toCardPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCardPay){
        this.ifCardPay = false
        
        
        if(this.card_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        }
        this.card_part_setted = false
        this.summ_card_part_pre = 0
      } else {
        this.summ_card_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCardPay = true
      }
    },
    setCashboxTerminal(){
      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      console.log(this.listCashbox)
      console.log(this.term_i)
      //if(this.listCashbox && this.listCashbox[this.term_i] && this.listCashbox[this.term_i].serial){
        console.log('по кассам')

        this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
          till_id: this.sale.org.serial
        }).then((resp) => {
        console.log(resp)
        if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
            this.cashboxTerminal = resp.cashbox.terminals[0].id
          } else {
            this.cashboxTerminal = null
            alert('Нет доступного терминала по выбранной кассе!')
        }
        //  } else {
        //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
        //  }
        })
     // }
    },
    handleSearch(input) {
      // console.log(+input)
      // if(input && +input && +input != NaN){
      //   input = '('+(+input)
      // }
      if (input && input.length >= 2) {
        this.$refs.myTree.updateAll(true)
      } else {
        this.$refs.myTree.updateAll(false)
      }
    },
    fetchFeed(buy_id, type){
      if (type === 'exist' || type === 'edit' || type === 'info') {
        this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id});
      }
      if (type === 'new' || type === 'edit') {
        //let org_inn = '1650387117'
        let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
        this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn});
      }
      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});

    },
    addCountNomenclature(item){
      item.count++;
      item.total = item.price * item.count;
    },
    subtractCountNomenclature(item){
      if (item.count !== 1) {
        item.count--;
        item.total = item.price * item.count;
      }
    },
    changeRental(){
      console.log(this.rentaItem)
      this.rentaItem.date_time_start = new Date()
      this.rentaItem.date_time_end = (new Date().getHours()+1) + ':00'

      let date = new Date()

      this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action));
      this.rentaItem.return_time = (new Date().getHours()+1) + ':00'

      this.$store.dispatch(salesActionTypes.getRentalsTypes,{type_locker_id: this.rentaItem.rental.type_locker_id})
        .then((response) => {
          if(response && response.rental) {
            //this.rentaItemDialog = true
          }
        });
    },
    addToNomenclature(item){

      console.log(item)

      console.log('--b--')

      if(item.rental){
        this.rentaItem = item
        this.rentaItem.id = item.id
        this.rentaItem.price = item.price
        this.rentaItem.name = item.name
        this.rentaItem.date_time_start = new Date()
        this.rentaItem.date_time_end = (new Date().getHours()+1) + ':00'

        this.rentaItem.rental.duration_of_action_def = this.rentaItem.rental.duration_of_action

        let date = new Date()

        this.rentaItem.return_date = new Date(new Date(date).setMonth(date.getMonth() + this.rentaItem.rental.duration_of_action));
        this.rentaItem.return_time = (new Date().getHours()+1) + ':00'

        this.rentaItem.rental = item.rental

        this.rentaItem.rental.summ = (this.rentaItem.rental.duration_of_action_def/this.rentaItem.rental.duration_of_action)*this.rentaItem.price

        this.$store.dispatch(salesActionTypes.getRentalsTypes,{type_locker_id: this.rentaItem.rental.type_locker_id})
        .then((response) => {
          if(response && response.rental) {
            this.rentaItemDialog = true
            this.rentaItem.rentalType = this.rentalsTypes.rental[0]
            this.chosedRentalType = this.rentalsTypes.rental[0]
          }
        });

        
      } else {

        console.log('--b-1-')

        let list = [];

        list = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures;

        if (list.findIndex(n => n.service.id === item.id) !== -1) {

          let nomenclature = list.find(n => n.service.id === item.id);

          if(!this.noCountServices[nomenclature.type]){
            nomenclature.count++;
            nomenclature.total = nomenclature.total * nomenclature.count;
          } else {
            item.count = 1;
            let price = (item.price === -1 ? 0 : item.price);
            list.push({
              service: {
                id: item.id,
                name: item.name
              },
              price,
              count: item.count,
              discount: item.discount ? item.discount : 0,
              total: price * item.count,
              specialist_id:null,
              activation_type: item.activation_type ? item.activation_type : null,
              type: item.type ? item.type : null,
              vat_id: item.vat ? item.vat.id : null,
              vat_count: item.vat ? item.vat.count : null,
              vat: item.vat ? item.vat : null
            });
          }

        } else {

          console.log('--b-2-')

          item.count = 1;
          let price = (item.price === -1 ? 0 : item.price);
          list.push({
            service: {
              id: item.id,
              name: item.name
            },
            price,
            count: item.count,
            discount: item.discount ? item.discount : 0,
            total: price * item.count,
            specialist_id:null,
            activation_type: item.activation_type ? item.activation_type : null,
            type: item.type ? item.type : null,
            vat_id: item.vat ? item.vat.id : null,
            vat_count: item.vat ? item.vat.count : null,
            vat: item.vat ? item.vat : null
          });
        }

        console.log(list)

        this.$store.dispatch(lessonActionTypes.getSpecialistList,{service_id:item.id});

      }

    },
    deleteFromNomenclature(item,rental){
      let list = [];
      list = rental ? this.rentalArray : this.nomenclatures

      if(rental){
        if (list.findIndex(n => n.id === item.id) !== -1) {
          list.splice(list.findIndex(n => n.id === item.id),1);
        }
      } else {
        if (list.findIndex(n => n.service.id === item.service.id) !== -1) {
          list.splice(list.findIndex(n => n.service.id === item.service.id),1);
        }
      }
    },
    printSaleBuy(){
      console.log(this.nomenclatures)
      if(!this.nomenclatures){
        alert('Печать договора не возможна!');
        return;
      }
      if (confirm("Документ еще не проведен. Выполнение действия возможно только после проведения документа. Документ будет проведен, продолжить?") == true) {
          console.log('continue')
        } else {
          return;
      }


      let list = [];
      let nomenclatures = [];
      nomenclatures = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures
      for (let item of nomenclatures) {
        console.log(item)
        list.push({
          service_id: item.service.id,
          name:item.service.name,
          price: item.price,
          count: item.count,
          discount: item.discount,
          discount_summ: (item.price * (item.discount/100)) * item.count,
          sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
          specialist_id: item.specialist_id,
          manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null,
          activation_date:item.activation_date_new,
          vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null
        })
      }

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){

            if (confirm("Предупреждение. Не привязан ИНН (касса) и не выбрана организация! Автоматически будет выбрана организация ООО КлеверСпорт") == true) {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
            } else {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
              return;
            }


          }
        }

        this.$store.dispatch(salesActionTypes.createSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0),
          client_id: this.client.client_id,
          fio: this.userFIO,
          service_list: list,
          manager_id:getItem('user_id_1c'),
          deal_id: this.deal_id ? this.deal_id : null
        })
            .then((response) => {
              
              if(response && response.sale && response.sale.buy_id){
                this.type = 'exist';
                  this.$store.dispatch(salesActionTypes.printSale,{
                    buy_id: response.sale.buy_id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      console.log(response2)
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                        this.$router.push({
                          name: 'Desktop',
                          params: {
                              client_id: this.client.client_id
                              }
                          });
                    } else {
                      alert('Ошибка генерации документа')
                    }
                
                  })
              } else {
                alert('Ошибка создания продажи!')
              }
      
            })

    },
    printSale(){
      console.log(this.saleInfo)
      if(!this.saleInfo.sales || !this.saleInfo.sales.buy_list){
        alert('Печать договора не возможна!');
        return;
      }
      this.$store.dispatch(salesActionTypes.printSale,{
                    buy_id: this.saleInfo.sales.id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      console.log(response2)
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      this.$router.push({
                          name: 'Desktop',
                          params: {
                              client_id: this.client.client_id
                              }
                          });s
                    } else {
                      alert('Ошибка генерации документа')
                    }
                
                  })

    },
    changeToEdit() {
      this.type = 'edit'
      this.fetchFeed(this.saleInfo.sales.id, this.type);
    },
    makeFreePayment(){

      console.log('freepayment')
      //return;

        // if(!this.sale || !this.sale.org || !this.sale.org.inn){
        //   alert('Не подключена или неполадки с кассой! Автоматически подставлена касса')
        //   return
        // }

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){
            alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
            return;
          }
        }

        if((this.dialogTypeOfPayment + 1) === 3) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            return;
          }
        }

        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null,
            vat:{
              id:item.vat ? item.vat.id : null,
              sum:item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            },
            vat_id: item.vat ? item.vat.id : null,
            vat_summ: item.vat ? ((item.price * item.vat.count)/(100+item.vat.count)) : 0,
            vat_count: item.vat ? item.vat.count : null
          })
        }
        if (this.type === 'new') {
          this.$store.dispatch(salesActionTypes.createSale, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list,
            deal_id: this.deal_id ? this.deal_id : null
          })
              .then((response) => {
                if (response.success) {
                  this.buy_id_payment = response.sale.buy_id;
                  this.$store.dispatch(cashboxActionTypes.saleReceipt, {
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          this.$store.dispatch(cashboxActionTypes.makePayment, {
                            buy_id: this.buy_id_payment,
                            till_id: this.sale.org.serial,
                            type: this.dialogTypeOfPayment + 1,
                            summ: Math.abs(this.summForPayment),
                            check_number: response.receipt_number,
                            bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                            terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                            transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                            transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                            fio: this.userFIO,
                            service_list: list
                          })
                              .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                }
                              })
                        } else {
                          alert('Ошибка оплаты!');
                        }
                      })
                }
              })
        } else {
          this.$store.dispatch(cashboxActionTypes.saleReceipt, {
            till_id: this.sale.org.serial,
            type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(cashboxActionTypes.makePayment, {
                    buy_id: this.saleInfo.sales.id,
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment + 1,
                    summ: Math.abs(this.summForPayment),
                    check_number: response.receipt_number,
                    bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                    terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                    transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                    transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          if (this.for === 'client') {
                            this.$router.push({
                              name: 'Desktop',
                              params: {
                                client_id: this.client.client_id
                              }
                            });
                          } else {
                            this.$store.dispatch(dealsActionTypes.updateSuccess, {
                              deal_id: this.deal,
                              buy_id: this.saleInfo.sales.id
                            }).then((response) => {
                              if (response.success) {
                                this.$router.push({
                                  name: 'Desktop',
                                  params: {
                                    client_id: this.client.client_id
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                } else {
                  alert('Ошибка оплаты!');
                }
              })
        }
    },
    cancelReceipt() {
      this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
        till_id: this.sale.org.serial,
        fio: this.userFIO
      })
    },
    ChangeSaleOrg(){

      console.log(this.buyer_sale_main)

      this.buyer_sale_main = null

      this.$store.dispatch(billActionTypes.getListBill,{
                    client_id: this.client_id,
                    org_id:this.saleOrg.id
                }).then((response2) => {
                      if (response2.success)
                      {

                      }
                      
            })
      // this.sale_org_changed = true

      // let confirmText = "При смене организации сбросится выбранный список услуг (сервисов)."

      // alert(confirmText);

      // this.nomenclatures = []

      // let org_inn = (this.sale && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0)
      // this.$store.dispatch(salesActionTypes.getSalesAllList, {org_inn});

      // // if (confirm(confirmText) == true) {
      // //   this.nomenclatures []
      // // } else {

      // // }

    },
    setCashPart(status){

      if(status && status === true) {
        if((+this.cash_in_part >= +this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.ifCashPay = false
          return;
        }

        if(+this.cash_in_part_pre > 0){
          this.cash_in_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.cash_in_part_pre)) : (this.cash_in_part - (+this.cash_in_part_pre))
        } else {
          this.cash_in_part_pre = 0
        }

      } else {
        this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        this.cash_in_part_pre = 0
        this.cash_in_part_setted = status
        this.ifCashPay = false
      }
   
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCashPay = false
      // }
 
     


    },
    setCardPart(status){

      if(status && status === true) {
        if((+this.cash_in_part >= +this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.ifCardPay = false
          return;
        }
        
        if(+this.summ_card_part_pre > 0){
          this.card_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_card_part_pre)) : (this.cash_in_part - (+this.summ_card_part_pre))
        } else {
          this.summ_card_part_pre = 0
        }
   
      } else {
        this.card_part_setted = status
        this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        this.summ_card_part_pre = 0
        this.ifCardPay = false
      }

   
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCardPay = false
      // }
   

    },
    setBillPart(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bill_part = null
          this.canAddSumm = false
        }

        if(+this.summ_bill_part_pre > 0){
          this.bill_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre)) : (this.cash_in_part - (+this.summ_bill_part_pre))
        } else {
          this.summ_bill_part_pre = 0
        }
      } else {
        this.bill_part_setted = status
        this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)
        this.summ_bill_part_pre = 0   
      }

    
    },
    setBillPart2(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bill_part2 = null
          this.canAddSumm = false
        }

        
        if(+this.summ_bill_part_pre2 > 0){
          this.bill_part_setted2 = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre2)) : (this.cash_in_part - (+this.summ_bill_part_pre2))
        } else {
          this.summ_bill_part_pre2 = 0
        }

      } else {
        this.bill_part_setted2 = status
        this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)
        this.summ_bill_part_pre2 = 0   

      }

    },
    setBonusPart(status){

      if(status && status === true) {
        if((this.cash_in_part > this.summ_cash_part) && status){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
          this.main_bonus_part = null
          this.canAddSumm = false
        }

        if(+this.summ_bonus_part_pre > this.main_bonus_part.bonus_limit){
          alert('Превышен лимит по бонусному счёту!')
          this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
          this.bonus_part_setted = false
        }
        if(+this.summ_bonus_part_pre > 0){
          this.bonus_part_setted = status
          this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bonus_part_pre)) : (this.cash_in_part - (+this.summ_bonus_part_pre))

        } else {
          this.summ_bonus_part_pre = 0
        }
      } else {
        this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)
        this.summ_bonus_part_pre = 0
        this.bonus_part_setted = status
      }

    


      console.log(this.summ_bonus_part_pre)
      console.log(this.main_bonus_part.bonus_limit)
      console.log(this.summ_cash_part)
      console.log(this.main_bonus_part)

    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      isLoadingSale: state => state.sale.isLoadingSale,
      listAllServices: state => state.sale.listAllServices,
      listBill: state => state.bill.list,
      listBonus: state => state.bill.bonus,
      saleInfo: state => state.sale.saleInfo,
      userFIO: state => state.userFIO,
      specialist: state => state.lesson.specialist,
      validationErrors: state => state.cashbox.validationErrors,
      listOrganizations: state => state.sale.listOrganizations
    }),
    searchPackages() {
      let res = this.caseSensitive
        ? sayMyNane(item, search, textKey)
        : undefined

        function sayMyNane(item, search, textKey){
          (item[textKey2].indexOf(search) > -1)
        }

      return res

    },
    
    summ() {
      return this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
    },
    summForPayment() {
      let money = null;
      if (this.dialogTypeOfPayment === 0) {
        money = this.cash_in <= this.summ ? this.cash_in : this.summ;
      }
      if (this.dialogTypeOfPayment === 1) {
        money = this.cash_from_bill;
      }
      if (this.dialogTypeOfPayment === 2) {
        money = this.summ;
      }
      if (this.dialogTypeOfPayment === 3) {
        money = this.summ;
      }
      return money;
    },
    summForPaymentPart() {
      let money = null;
      if(this.dialogTypeOfPaymentPart.includes(0)){
        money = this.cash_in_part <= this.summ_part ? this.cash_in_part : this.summ_part;
      }
      if (this.dialogTypeOfPaymentPart.includes(1)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_bill_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_bill_part;
        }
      }
      if (this.dialogTypeOfPaymentPart.includes(2)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_card_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_card_part;
        }
      }

      return money;
    }
  },
  mounted() {

    if (JSON.parse(getItem('select_org-sale')) && this.listCashbox) {
      this.sale.org = JSON.parse(getItem('select_org-sale'));
    } else {
      this.sale.org = this.listCashbox ? this.listCashbox[0] : null;
    }

    this.client_id !== undefined ? setItem('sale-buyer-client_id',this.client_id) : this.client_id = getItem('sale-buyer-client_id');
    this.client_name_buyer !== undefined ? setItem('sale-buyer-client_name_buyer',this.client_name_buyer) : this.client_name_buyer = getItem('sale-buyer-client_name_buyer');
    this.org_inn !== undefined ? setItem('sale-buyer-org_inn',this.org_inn) : this.org_inn = getItem('sale-buyer-org_inn');

    this.service_list_buyer !== undefined ? setItem('sale-buyer-service_list_buyer',this.service_list_buyer) : this.service_list_buyer = getItem('sale-buyer-service_list_buyer');
    this.buy_id !== undefined ? setItem('sale-buyer-buy_id',this.buy_id) : this.buy_id = getItem('sale-buyer-buy_id');
    this.summ_cash_part_buyer !== undefined ? setItem('sale-buyer-summ_cash_part_buyer',this.summ_cash_part_buyer) : this.summ_cash_part_buyer = getItem('sale-buyer-summ_cash_part_buyer');
    this.summ_part_buyer !== undefined ? setItem('sale-buyer-summ_part_buyer',this.summ_part_buyer) : this.summ_part_buyer = getItem('sale-buyer-summ_part_buyer');

    console.log(this.client_id)
    console.log(this.client_name_buyer)
    console.log(this.org_inn)
    console.log(this.service_list_buyer)
    console.log(this.buy_id)
    console.log(this.summ_cash_part_buyer)
    console.log(this.summ_part_buyer)

    console.log(this.detail)
    console.log(this.pays)

    if(this.pays && this.pays[0]){
      
      this.buyer_text = this.pays[0].comment ? this.pays[0].comment : ''
      this.buyer_sale_main = this.pays[0].bank_account ? this.pays[0].bank_account : null

      console.log(this.buyer_sale_main)

    }

    this.$store.dispatch(salesActionTypes.getSalesOrganizations, {}).then((response) => {
        if(response && response.sales){
                console.log(response)
                let orgId = null
                let orgId2 = null
                let orgRes = null
                

                if(this.new_org) {

                  console.log(this.new_org)



                  if(response.sales[1] && response.sales[1].id === "5738e017-5875-11ea-80e1-9c5c8e747603") {
                      orgId = response.sales[1].id

                      if(response.sales[0]) {
                        orgId2 = response.sales[0].id
                      } else {
                        alert('Ошибка получения организаций!')
                        return;
                      }

                    } else if(response.sales[1]){
                      orgId = response.sales[0].id

                      if(response.sales[0]) {
                        orgId2 = response.sales[1].id
                      } else {
                        alert('Ошибка получения организаций!')
                        return;
                      }
                    }

                    orgRes = orgId


                      if(response.sales[1] && response.sales[1].id === "5738e017-5875-11ea-80e1-9c5c8e747603") {
          
                        if(this.new_org.id === "5738e017-5875-11ea-80e1-9c5c8e747603"){
                          this.saleOrg = response.sales[1] ? response.sales[1] : null
                        } else {
                          orgRes = orgId2
                          this.saleOrg = response.sales[0] ? response.sales[0] : null
                        } 

                      } else {
                        if(this.new_org.id === "5738e017-5875-11ea-80e1-9c5c8e747603"){
                          this.saleOrg = response.sales[0] ? response.sales[0] : null
                        } else {
                          orgRes = orgId2
                          this.saleOrg = response.sales[1] ? response.sales[1] : null
                        } 
                      }


                } else {

                    if(response.sales[1] && response.sales[1].id === "5738e017-5875-11ea-80e1-9c5c8e747603") {
                      orgId = response.sales[1].id

                      if(response.sales[0]) {
                        orgId2 = response.sales[0].id
                      } else {
                        alert('Ошибка получения организаций!')
                        return;
                      }

                    } else if(response.sales[1]){
                      orgId = response.sales[0].id

                      if(response.sales[0]) {
                        orgId2 = response.sales[1].id
                      } else {
                        alert('Ошибка получения организаций!')
                        return;
                      }
                    }


                    
                    orgRes = orgId

                    if(this.pays && this.pays[0]){

                      if(response.sales[1] && response.sales[1].id === "5738e017-5875-11ea-80e1-9c5c8e747603") {
          
                      if(this.pays[0].cash_register.id === "54b314d2-5877-11ea-80e1-9c5c8e747603"){
                          this.saleOrg = response.sales[1] ? response.sales[1] : null
                        } else {
                          orgRes = orgId2
                          this.saleOrg = response.sales[0] ? response.sales[0] : null
                        } 

                      } else {
                        if(this.pays[0].cash_register.id === "54b314d2-5877-11ea-80e1-9c5c8e747603"){
                          this.saleOrg = response.sales[0] ? response.sales[0] : null
                        } else {
                          orgRes = orgId2
                          this.saleOrg = response.sales[1] ? response.sales[1] : null
                        } 
                      }

                    }

              }




                this.$store.dispatch(billActionTypes.getListBill,{
                    client_id: this.client_id,
                    org_id:orgRes
                }).then((response2) => {
                      if (response2.success)
                      {
                        if(response2.list && response2.list.length === 1){
                          this.buyer_sale_main = response2.list[0]
                        }
                        
                      }
                      
                 })


          

        } else {
          alert('Ошибка получения организаций!')
        }
      
    });



    // this.buy_id !== undefined ? setItem('sale-buy_id',this.buy_id) : this.buy_id = getItem('sale-buy_id');
    // console.log(this.listCashbox)
    // //console.log(this.listCashboxDef)

    // if (JSON.parse(getItem('select_org-sale')) && this.listCashbox) {
    //   this.sale.org = JSON.parse(getItem('select_org-sale'));
    // } else {
    //   this.sale.org = this.listCashbox ? this.listCashbox[0] : null;
    // }
    

  },
  // watch: {
  //   canAddSumm(){
     
  //   },
  //   summ_cash_part(){
  //     if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
  //       this.summ_card_part = this.summ_part - this.summ_cash_part;
  //       this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
  //     }
  //   },
  //   summ_card_part(){

  //     if(this.dialogTypeOfPaymentPart.includes(0) && !this.dialogTypeOfPaymentPart.includes(1)){
  //       this.summ_cash_part = this.summ_part - this.summ_card_part;
  //       this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
  //     }
  //   },
  //   cash_in_part() {

  //     if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
  //       this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
  //     } else {
  //       this.cash_out_part = this.cash_in_part > this.summ_cash_part ? (this.cash_in_part - this.summ_cash_part) : 0;
  //     }
  //   },
  //   summ_bill_part(){
  //     console.log(this.summ_bill_part)
  //   },
  //   main_bill_part_def(){
  //     console.log(this.main_bill_part_def)
  //     if(this.main_bill_part && this.main_bill_part !== null){
  //       //уже выбран один
  //       console.log('уже есть один')
        
  //       if(this.main_bill_part_def !== null){

  //         if(+this.main_bill_part_def.deposit_balance > 0){
  //           this.main_bill_part2 = this.main_bill_part_def
  //         }

  //         if(+this.cash_in_part >= +this.summ_cash_part){
  //           alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
  //           this.canAddSumm = false
  //           if(this.main_bill_part_def.deposit_id === this.main_bill_part2.deposit_id){
  //             this.main_bill_part2 = null
  //           }
            
  //           return;
  //         }
  //         if(+this.main_bill_part2.deposit_balance <= 0){
  //           alert('Не верный баланс счёта')
  //           this.bill_part_setted2 = true

  //           this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)

  //           this.summ_bill_part_pre2 = 0

  //         } else {
  //           this.bill_part_setted2 = false
  //         }
  //       }

  //     } else {

  //       if(this.main_bill_part_def !== null){
          
  //         if(+this.main_bill_part_def.deposit_balance > 0){
  //           this.main_bill_part = this.main_bill_part_def
  //         }
          
  //         if(+this.cash_in_part >= +this.summ_cash_part){
  //           alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
  //           this.canAddSumm = false
  //           if(this.main_bill_part_def.deposit_id === this.main_bill_part.deposit_id){
  //             this.main_bill_part = null
  //           }
  //           return;
  //         }
  //         if(+this.main_bill_part.deposit_balance <= 0){
  //           alert('Не верный баланс счёта')
  //           this.bill_part_setted = true

  //           this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)

  //           this.summ_bill_part_pre = 0

  //         } else {
  //           this.bill_part_setted = false
  //         }
  //       }

  //     }
  //   },
  //   main_bonus_part(){
  //     if(this.main_bonus_part !== null){
  //       console.log(this.cash_in_part_pre)
  //       console.log(this.cash_in_part)
  //       console.log(this.summ_bonus_part_pre)
  //       console.log(this.main_bonus_part)
  //       if(+this.cash_in_part >= +this.summ_cash_part){
  //         alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
  //         this.canAddSumm = false
  //         this.main_bonus_part = null
  //         return;
  //       }

  //       if(+this.main_bonus_part.deposit_balance <= 0){
  //         this.bonus_part_setted = true

  //         this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)

  //         this.summ_bonus_part_pre = 0

  //       } else {
  //         this.bonus_part_setted = false
  //         this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
  //       }
  //     }
  //   },
  //   cash_in() {
  //     this.cash_out = this.cash_in > this.summ ? (this.cash_in - this.summ) : 0;
  //   },
  //   'sale.org'() {
  //     console.log(this.sale.org)
  //     setItem('select_org-sale',JSON.stringify(this.sale.org))
  //     if(+this.term_i === 0){
  //       this.term_i = 1
  //     } else {
  //       this.term_i = 0
  //     }
  //     this.setCashboxTerminal()
  //   },
  //   'salePart'(){
  //     console.log(this.salePart)
  //   },
  //   'dialogTypeOfPaymentPart'(){
  //     console.log(this.dialogTypeOfPaymentPart)
  //   }
  // },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style scoped>
#horizontal_tabs {
  flex: none;
  width: auto !important;
}
.logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.total-price > span {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.service {
  width: 100%;
  padding: 0px 16px;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  margin-top: 10px;
}
.service-title {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.service-price {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
}
.new-client {
  border-top: 1px solid #E0E0E0;
  margin: 0 16px 20px 16px;
  padding-top: 20px;

}
.new-client > span {
  margin-top: 20px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #629F33;
  cursor: pointer;
}
.payment-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.no-data-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #767676;
  padding-left: 16px;
  padding-bottom: 16px;
}
.custom__select {
  width: 330px;
}
.custom__select.v-select--is-menu-active {
  outline: 4px solid #E0ECD6;
}
.search-service.v-input--is-focused {
  outline: 4px solid #E0ECD6;
}
.custom__text-field {
  font-size: 12px;
  font-weight: normal;
  padding: 20px 16px 16px 16px;
}
.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}
.vd-activator .custom__datepicker {
  width: 92% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #969696 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}


.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px!important;
  color: #767676!important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.v-btn-toggle > v-btn {
  width: 25%;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}
.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.button__secondary-text {
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.vd-activator .custom__datepicker2 {
border: unset !important;
    background: transparent !important;
    padding: 13px 16px !important;
    margin-top: 0px !important;
}

.vd-activator .custom__datepicker44 {

    margin: 0px 0px 0px -12px !important;
    border:1px solid #e0e0e0 !important;
}

</style>